class ImageBannerMobileSlideshow extends HTMLElement {
  constructor() {
    super();

    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed)
    };

    if(theme.config.mqlSmall) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickity = new Flickity(this, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        draggable: false,
        setGallerySize: true,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      });
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickity && this.flickity.stopPlayer();
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? 'right' : 'left';
  }

  matchMedia() {
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.init();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
    });
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
    }
  }
}
customElements.define('image-banner-mobile-slideshow', ImageBannerMobileSlideshow);